import ModalHandle from './ModalHandle';

class AlertModalHandle extends ModalHandle {
}

export default AlertModalHandle;
